module.exports = __webpack_public_path__ + "img/kopernik-logo-black-new.525408af.png";